import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable()
export class ClientDataHelper {
  constructor(private http: HttpClient) {}

  public storeData (data : any, name : string){
    sessionStorage.setItem(name, JSON.stringify(data));
  }

  public getData(name : string) {
    return JSON.parse(sessionStorage.getItem(name));
  }

  public getIpAddress(data) {
    data = data.replace(new RegExp('\r?\n', 'g'), ',');
    var formattedData = data.split(',');
    for (var i = 0; i < formattedData.length; i++) {
      if (formattedData[i].includes("ip=")) {
        return formattedData[i].replace('ip=', '').trim();
      }
    };
    return '';
  }
}
